module.exports = __webpack_public_path__ + "img/1.7cf8db8f.jpg";